// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root___wieE","header":"MergedInvoice_header__2DqmJ"};